module.exports = __webpack_public_path__ + "media/en_us_s1_Beckie.5137ac8f.oga";